import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { ManufacturerDto } from '../../../../shared/dtos/manufacturer.dto';
import { ProgressData } from '../../../../shared/dtos/progress-data';
import { ResponseModel } from '../../../../shared/models/reponse.model';
import { ManufacturersService } from '../../../../shared/services/manufacturers.service';
import { ProgressIndicatingService } from '../../../../shared/services/progress-indicating.service';
import { PacData } from '../../dtos/pacData';
import { TransferContractDto } from '../../dtos/transfer-contract.dto';
import { TransferContractService } from '../../services/transfer-contract.service';

@Component({
    selector: 'app-transfer-contract',
    templateUrl: './transfer-contract.component.html',
    styleUrls: ['./transfer-contract.component.scss']
})
export class TransferContractComponent implements OnInit {
    @ViewChild('transferForm')public _transferForm : any;
    public currentPac: string = '';
    public manufacturers: ManufacturerDto[];
    public selectedManufaturer: string;
    public notes: string = '';
    public newPac: string = '';
    public responseMessage: string = '';
    public pacData = new PacData();

    private _unsubscribe$: Subject<void> = new Subject<void>();
    private _progress$: Subject<ProgressData> = new Subject<ProgressData>();

    public constructor(
        private manufacturersService: ManufacturersService,
        private transferContractService: TransferContractService,
        private progressService: ProgressIndicatingService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        private _router: Router
    ) {
    }

    public ngOnDestroy(): void {
        this._progress$.next();
        this._progress$.complete();
        this._unsubscribe$.next();
        this._unsubscribe$.complete();
    }

    public ngOnInit(): void {
        this.progressService.show({
            initial: {
                done: false,
                header: 'Loading Manufacturer Details',
                details: 'Please wait...'
            },
            progress$: this._progress$
        });
        this.manufacturersService
            .getAllManufacturers()
            .pipe(
                map(res => res.manufacturerModel),
                takeUntil(this._unsubscribe$)
            )
            .subscribe(
                (response: ManufacturerDto[]) => {
                    this.manufacturers = response;
                    // this.selectedManufaturer = response[0].manufacturerName;
                    this.sendProgressDoneSignal();
                },
                () => {
                    this.sendProgressDoneSignal();
                    this.messageService.add({ severity: 'error', summary: 'Fail', detail: 'Unable to load manufaturers.' });
                });
    }

    private sendProgressDoneSignal(): void {
        this._progress$.next({
            header: '',
            done: true
        });
    }

    public onTransferContractClicked(): void {
        this.confirmationService.confirm({
            header: 'Confirmation',
            message: 'Do you want to transfer this contract ?',
            accept: /* istanbul ignore next */ () => this.handleTransferContract()
        });
    }

    private handleTransferContract(): void {
        this.progressService.show({
            initial: {
                done: false,
                header: 'Transferring',
                details: 'Please wait...'
            },
            progress$: this._progress$
        });
        const data: TransferContractDto = {
            oldPac: this.pacData.currentPac!,
            newPac: this.pacData.newPac!,
            field1: this.notes,
            manufacturerName: this.selectedManufaturer
        };
        this.transferContractService
            .transferContract(data)
            .pipe(takeUntil(this._unsubscribe$))
            .subscribe(
                (res) => {
                    const response = new ResponseModel(res);
                    this.sendProgressDoneSignal();
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: response.message });
                    this.clearFields();
                },
                (error) => {
                    const response = new ResponseModel(error.error);
                    this.sendProgressDoneSignal();
                    this.messageService.add({ severity: 'error', summary: 'Fail', detail: response.message });
                });
    }

    private clearFields() : void {
        this.notes = '';
        this.selectedManufaturer = '';
        if (this._transferForm.valid) {
            this._transferForm.reset();
        }
    }
}
